import { defineComponent } from 'vue';
import ConfigListHeader from '@/layouts/cashier-settings-page/config-list/config-list-header/config-list-header.vue';
import ConfigListTable from '@/layouts/cashier-settings-page/config-list/config-list-table/config-list-table.vue';

export default defineComponent({
  name: 'ConfigList',
  components: {
    ConfigListHeader,
    ConfigListTable,
  },
});
